(() => {
  if (window.__luaCorporateControlsInstalled) return;
  window.__luaCorporateControlsInstalled = true;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const isFilter = form.matches('[data-lcc-filter-form]');
    const isSort = form.matches('[data-lcc-sort-form]');
    if (!isFilter && !isSort) return;

    event.preventDefault();
    const next = new URL(window.location.href);
    if (isFilter) {
      for (const key of [...next.searchParams.keys()]) {
        if (key.startsWith('filter.')) next.searchParams.delete(key);
      }
      for (const [key, value] of new FormData(form)) {
        if (typeof value !== 'string' || value.trim() === '') continue;
        if (key === 'sort_by') next.searchParams.set(key, value);
        else next.searchParams.append(key, value);
      }
    } else {
      const select = form.querySelector('select[name="sort_by"]');
      if (!select || !select.value) return;
      next.searchParams.set('sort_by', select.value);
    }
    next.searchParams.delete('page');
    next.hash = 'CorporateCatalog';
    window.location.assign(next.href);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    const panel = target.closest('[data-lcc-disclosure][open]');
    if (!panel) return;
    panel.open = false;
    panel.querySelector('summary')?.focus();
  });
})();
